export const ADHERENCE_COLOR = '#084AB5';
export const ADHERENCE_COLOR_LIGHT = '#E6EFFF';
export const ROOKIE_COLOR = '#F86308';
export const GIVER_COLOR = '#081F41';
export const SUPER_GIVER_COLOR = '#64272A';
export const ULTIMATE_GIVER_COLOR = '#C05EEC';
export const BETTERFLYER_COLOR = '#009E86';
export const WHITE = '#FFFFFF';
export const DARK_BLUE_800 = '#394C67';
export const GRAY_BLUE_800 = '#B0B7C3';
export const DARK_BLUE_1400 = '#051327';
export const PRIMARY_BLUE_75 = '#084AB5';
export const PRIMARY_DEEPBLUE_20 = '#8BBBFF';
export const PRIMARY_DEEPBLUE_70 = '#0759D5';
export const PRIMARY_VIVID_ORANGE_20 = '#FFAE00';
export const PRIMARY_LIGHTBLUE_1000 = '#084BB9';
export const PRIMARY_LIGHTBLUE_600 = '#6B93D5';
export const PRIMARY_LIGHTBLUE_30 = '#B5C9EA';
export const PRIMARY_NEUTRAL_10 = '#F0F0F0';
export const PRIMARY_NEUTRAL_20 = '#E3E3E3';
export const PRIMARY_NEUTRAL_50 = '#555E66';
export const PRIMARY_POWERBLUE_50 = '#0773DF';
export const PRIMARY_ULTRAORANGE_20 = '#FFA733';
export const GRAY_BLUE_400 = '#D7DBE1';
export const ERROR_COLOR = '#D43D42';
export const SUCCESS_COLOR = '#109E89';
export const INFORMATIVE_COLOR = '#007BC2';
export const ALERT_COLOR = '#E59D00';
export const SECONDARY_BRIGHTPURPLE_30 = '#DB8CFF';
export const SECONDARY_BRIGHTPURPLE_40 = '#C864F5';
export const SECONDARY_GREENAQUA_10 = '#7DF0DF';
export const SECONDARY_PURPLE_20 = '#BFBFFF';
export const SECONDARY_SKYBLUE_10 = '#C2EEFF';
export const SECONDARY_VALENTINERED_20 = '#FFA6A9';
export const SECONDARY_YELLOW_10 = '#FFE459';
export const MAIN_BRAND_PRIMARY = '#26fe7e';
export const CHART_TEXT = '#40474E';

export const CARD_PRIMARY = '#FFFFFF';
export const CONTROLLER_OFF_BORDER = '#404F46';
export const CONTROLLER_OFF_BORDER_DISABLED = '#869C8F';
export const CONTROLLER_ON = '#0F1C14';
export const BRAND_SECONDARY = '#E9FD3F';
export const BRAND_SECONDARY_LIGHT = '#F9FECD';
export const BRAND_TERTIARY = '#FEADFC';
export const BRAND_TERTIARY_LIGHT = '#FFE6FE';
export const BRAND_QUATERNARY = '#5FFFEB';
export const BRAND_QUATERNARY_LIGHT = '#D6FFFA';

export const BRAND_PRIMARY = '#26FE7E';

export const GREYSCALE_30 = '#C4CFC8';
export const GREYSCALE_WHITE = 'FFFFFF';

export const SEMANTIC_ALERT = '#FE9001';
export const SEMANTIC_ERROR = '#E40109';
export const SEMANTIC_INFO = '#0167FE';
export const SEMANTIC_SUCCESS = '#019866';

export const COLOR_ON_SURFACE_OUTLINE_OUTLINE_ENABLED = '#0F1C14';
export const COLOR_ON_SURFACE_TEXT_ON_SURFACE_TEXT = '#0F1C14';
export const COLOR_ON_SURFACE_TEXT_ON_SURFACE_TEXT_VARIANT = '#333E37';
